import React, { useState, useEffect } from 'react';
import {
  HL_SLIPPAGE_PRESETS,
  HL_SLIPPAGE_DEFAULT_MODE,
  formatHlSlippageLabel,
  resolveHlSlippageBps,
} from '../utils/hlSlippage';
import { loadHlSlippageSettings, saveHlSlippageSettings } from '../utils/hlSlippageStorage';
import './HlSlippageSettings.css';

export default function HlSlippageSettings() {
  const [mode, setMode] = useState(HL_SLIPPAGE_DEFAULT_MODE);
  const [customPct, setCustomPct] = useState('10');
  const [savedLabel, setSavedLabel] = useState(null);

  useEffect(() => {
    const stored = loadHlSlippageSettings();
    setMode(stored.mode);
    setCustomPct(stored.customPct);
  }, []);

  const persist = (nextMode, nextCustom) => {
    const settings = { mode: nextMode, customPct: nextCustom };
    saveHlSlippageSettings(settings);
    const bps = resolveHlSlippageBps(nextMode, nextCustom);
    setSavedLabel(bps != null ? formatHlSlippageLabel(bps) : null);
    setTimeout(() => setSavedLabel(null), 2000);
  };

  const selectMode = (nextMode) => {
    setMode(nextMode);
    persist(nextMode, customPct);
  };

  const onCustomChange = (value) => {
    setCustomPct(value);
    if (mode === 'custom') persist('custom', value);
  };

  const activeBps = resolveHlSlippageBps(mode, customPct);

  return (
    <div className="hl-slippage-settings">
      <h3>Market order slippage</h3>
      <p className="hl-slippage-settings-sub">
        Default cap for Single Asset market orders (IOC). Saved in this browser — applies to paper and live.
      </p>
      <div className="hl-slippage-options">
        {HL_SLIPPAGE_PRESETS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className={mode === preset.id ? 'active' : ''}
            onClick={() => selectMode(preset.id)}
          >
            {preset.label}
          </button>
        ))}
        <button
          type="button"
          className={mode === 'custom' ? 'active' : ''}
          onClick={() => selectMode('custom')}
        >
          Custom
        </button>
      </div>
      {mode === 'custom' && (
        <div className="hl-slippage-custom">
          <label htmlFor="hl-slippage-custom-pct">Custom max %</label>
          <input
            id="hl-slippage-custom-pct"
            type="number"
            min={0.01}
            max={100}
            step={0.1}
            value={customPct}
            onChange={(e) => onCustomChange(e.target.value)}
            placeholder="e.g. 10"
          />
        </div>
      )}
      <p className="hl-slippage-active">
        Active setting:{' '}
        <strong>{activeBps != null ? formatHlSlippageLabel(activeBps) : 'Enter a valid custom %'}</strong>
        {savedLabel && <span className="hl-slippage-saved"> · Saved</span>}
      </p>
    </div>
  );
}
